<template>
  <div class="card">
    <div class="card-header">
      <h4>Ausstattung</h4>
    </div>
    <div class="card-body">
      <b-row>
        <b-col md="12" class="list_mode iam-table-ux">
          <b-input-group class="datatable-btn">
            <div class="input-group">
              <b-form-input style="border:1px solid lightgrey" v-model="tbl_filter.bauprojekt_ausstattung" placeholder="Suchen"></b-form-input>
            </div>
          </b-input-group>
        </b-col>
      </b-row>
      <div class="table-responsive datatable-vue">
        <b-table
          show-empty
          :items="bauprojekt_ausstattung"
          :filtered="onFilteredBauprojektAusstattung"
          :current-page="tbl_currentPage.bauprojekt_ausstattungg"
          :filter="tbl_filter.bauprojekt_ausstattung"
          :per-page="tbl_perPage.bauprojekt_ausstattung"
          :fields="tbl_fields.bauprojekt_ausstattung"
        >
          <template slot="empty"><div class="text-center">Keine Ausstattungselemente zugewiesen</div></template>
          <template v-slot:cell(actions)="row">
             <feather :id="'remove_as_bp' + row.item.id" type="minus-circle" class="infra-blue pointer" @click="unassignToBp(row.item.ausstattung_id.id)"></feather>
              <b-tooltip :target="'remove_as_bp' + row.item.id" triggers="hover" placement="left">Zuweisung aufheben</b-tooltip>
          </template>
        </b-table>
      </div>
        <div class="tbl-bottom-bar" >
          <div class="pagination-container">
            <b-pagination 
            v-if="tbl_totalRows > tbl_perPage"
              v-model="tbl_currentPage.bauprojekt_ausstattung"
              :total-rows="tbl_totalRows.bauprojekt_ausstattung"
              :per-page="tbl_perPage.bauprojekt_ausstattung"
              class="my-0"
            ></b-pagination>
          </div>
          <div class="flex-row-end" style="margin-top:10px;">
            <b-button class="btn btn-primary" @click="openModalAssignAusstattung()">Ausstattung bearbeiten</b-button>
          </div>
        </div>
    </div>
    <b-modal id="assignAusstattung" size="lg" ok-only @hide="rstModalAssignAusstattung" v-if="this.ready">
      <b-row>
        <b-col md="12" class="list_mode iam-table-ux">
          <b-input-group class="datatable-btn">
            <div class="input-group">
              <b-form-input style="border:1px solid lightgrey" v-model="tbl_filter.assign_ausstattung" placeholder="Suchen"></b-form-input>
            </div>
          </b-input-group>
        </b-col>
      </b-row>
      <div class="table-responsive datatable-vue">
        <b-table
          show-empty
          :items="assign_ausstattung"
          :filtered="onFilteredAssignAusstattung"
          :current-page="tbl_currentPage.assign_ausstattungg"
          :filter="tbl_filter.assign_ausstattung"
          :per-page="tbl_perPage.assign_ausstattung"
          :fields="tbl_fields.assign_ausstattung"
        >
          <template slot="empty"><div class="text-center">Keine Ausstattungselemente zugewiesen</div></template>
          <template v-slot:cell(actions)="row">
              <transition :name="animations.standard.name" :enter-active-class="animations.standard.enter" :leave-active-class="animations.standard.leave" mode="out-in">
            <div v-if="isAssigned(row.item.id)">
              <feather :id="'assign_as_' + row.item.id" type="plus-circle" class="infra-blue pointer" @click="assignToBp(row.item.id)"></feather>
              <b-tooltip :target="'assign_as_' + row.item.id" triggers="hover" placement="left">dem Bauprojekt zuweisen</b-tooltip>
            </div>
            <div v-if="!isAssigned(row.item.id)">
              <feather :id="'remove_as_' + row.item.id" type="minus-circle" class="infra-blue pointer" @click="unassignToBp(row.item.id)"></feather>
              <b-tooltip :target="'remove_as_' + row.item.id" triggers="hover" placement="left">Zuweisung aufheben</b-tooltip>
            </div>
                      </transition>

          </template>
        </b-table>
      </div>
      <b-col>
        <div class="tbl-bottom-bar">
          <div class="pagination-container">
            <b-pagination
              v-model="tbl_currentPage.assign_ausstattung"
              :total-rows="tbl_totalRows.assign_ausstattung"
              :per-page="tbl_perPage.assign_ausstattung"
              class="my-0"
            ></b-pagination>
          </div>
        </div>
      </b-col>
      <template slot="modal-header"><h4>Ausstattungen bearbeiten</h4></template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BauprojektAusstattung",
  components: {},
  props: ["bauprojekt_id"],
  computed: {
    ...mapGetters({
      animations: "app/animations",
      toasts: "app/toasts",
      assign_ausstattung: "fitting/ausstattung",
    }),
  },
  data() {
    return {
      ready: false,
      bauprojekt_ausstattung: [],
      updating: {
        bauprojekt_ausstattung: false,
        assign_ausstattung: false,
      },
      tbl_fields: {
        bauprojekt_ausstattung: [
          { key: "ausstattung_id.name", label: "Name", sortable: true },
          { key: "ausstattung_id.kategorie.name", label: "Kategorie", sortable: true },
          { key: "actions", label: "Aktionen", sortable: false },
        ],
        assign_ausstattung: [
          { key: "name", label: "Name", sortable: true },
          { key: "kategorie.name", label: "Kategorie", sortable: true },
          { key: "actions", label: "", sortable: false },
        ],
      },
      tbl_filter: {
        bauprojekt_ausstattung: null,
        assign_ausstattung: null,
      },
      tbl_currentPage: {
        bauprojekt_ausstattung: 1,
        assign_ausstattung: 1,
      },
      tbl_perPage: {
        abauprojekt_ausstattung: 10,
        assign_ausstattung: 10,
      },
      tbl_totalRows: {
        bauprojekt_ausstattung: 1,
        assign_ausstattung: 1,
      },
    };
  },
  async created() {
    await this.init();
  },
  methods: {
    async init() {
      try {
        this.updating.bauprojekt_ausstattung = true;
        const response = await this.$store.dispatch("fitting/getAusstattungBauprojekt", this.bauprojekt_id);
        this.bauprojekt_ausstattung = response;
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      } finally {
        this.updating.bauprojekt_ausstattung = false;
        this.ready = true;
      }
    },
    onFilteredBauprojektAusstattung(filteredItems) {
      this.tbl_totalRows.bauprojekt_ausstattung = filteredItems.length;
      this.tbl_currentPage.bauprojekt_ausstattung = 1;
    },
    onFilteredAssignAusstattung(filteredItems) {
      this.tbl_totalRows.assign_ausstattung = filteredItems.length;
      this.tbl_currentPage.assign_ausstattung = 1;
    },
    async openModalAssignAusstattung() {
      if (!this.assign_ausstattung.length) {
        try {
          this.updating.assign_ausstattung = true;
          await this.$store.dispatch("fitting/getAusstattung");
        } catch (error) {
          console.log(error);
          this.$toasted.show(error, this.toasts.failure);
        } finally {
          this.updating.assign_ausstattung = false;
        }
      }

      this.$bvModal.show("assignAusstattung");
    },
    rstModalAssignAusstattung() {
      console.log("restModal Assign was called");
    },
    isAssigned(ausId) {
      return this.bauprojekt_ausstattung.find((bpa) => bpa.ausstattung_id.id == ausId) == undefined ? true : false;
    },
    async assignToBp(ausId) {
        const payload = {
            bauprojekt_id: this.bauprojekt_id,
            ausstattung_id: ausId
        }
        try {
            this.updating.bauprojekt_ausstattung = true;
            await this.$store.dispatch("fitting/assignToBp", payload);
            const response = await this.$store.dispatch("fitting/getAusstattungBauprojekt", this.bauprojekt_id);
            this.bauprojekt_ausstattung = response;
        } catch(error) {
            console.log(error);
            this.$toasted.show(error, this.toasts.failure);
        } finally {
            this.updating.bauprojekt_ausstattung = false;
        }
    },
    async unassignToBp(ausId) {
        const relation = this.bauprojekt_ausstattung.find(r => r.ausstattung_id.id == ausId);
        const target = relation.id;

        try {
            this.updating.bauprojekt_ausstattung = true;
            await this.$store.dispatch("fitting/unassignToBp", target);
            const response = await this.$store.dispatch("fitting/getAusstattungBauprojekt", this.bauprojekt_id);
            this.bauprojekt_ausstattung = response;
        } catch(error) {
            console.log(error);
            this.$toasted.show(error, this.toasts.failure);
        } finally {
            this.updating_bauprojekt_ausstattung = false;
        }
    }
  },
};
</script>

<style></style>
